export enum OffsiteCampaignEndpoints {
  GET_SITE = '/sites/:siteId',
  OFFSITE_PUT = '/sites/:siteId/campaigns_offsite/:campaignId',
  OFFSITE_POST = '/sites/:siteId/campaigns_offsite',
  OFFSITE_GET_LIST = '/sites/:siteId/campaigns_offsite',
  OFFSITE_GET_BY_ID = '/sites/:siteId/campaigns_offsite/:campaignId',
}
